
	// $(window).on('resize', function () {

	// 	if($('.has-scroll-init').length>0){
	// 		setTimeout(() => {
	// 			window.UpdateMyScroll()

	// 		}, 400);
	// 	}
	// });

var appliedFilters = [];



window.addFilter= function(attributeCode, id) {
	var urlParams = new URLSearchParams(window.location.search);
	urlParams.forEach(function (value, index) {
		appliedFilters[index] = value.split(',');
	});

	if (appliedFilters[attributeCode] && appliedFilters.hasOwnProperty(attributeCode)) {
		if (appliedFilters[attributeCode].indexOf(String(id)) != -1) {
			appliedFilters[attributeCode].splice(appliedFilters[attributeCode].indexOf(String(id)), 1);
		} else {

			//appliedFilters[attributeCode].push(String(id));
			appliedFilters[attributeCode] = [String(id)];
		}
	} else {

		appliedFilters[attributeCode] = [String(id)];
	}

	var params = [];
	for (var key in appliedFilters) {
		if (key != 'page') {
			console.log('ss',appliedFilters[key]);
			if ( appliedFilters[key].length > 0) 
			   params.push(key + '=' +  appliedFilters[key].join(','));
		}
	}
	var url = window.location.href.split('#')[0];
	url = url.split('?')[0] + "?" + params.join('&');
		url = url.split('?')[0] + "?" + params.join('&');

	window.history.pushState("", "", url);
	window.getpage(url + ' .innerToChange > *');
}

window.getpage = function(page, img, product_search) {

    $('.preloader').removeClass('d-none')
    $('.preloader').fadeIn(0);

    $('.innerToChange').load(page, function() {
        setTimeout(function() {

            $('.preloader').fadeOut(1100);
            // $('html, body').animate({
            //     scrollTop: $('.innerToChange').offset().top - 100
            // }, '100');
            //afterGetPage();
            if (typeof afterGetPageInitJs === "function") {
                afterGetPageInitJs();
            }

			if($('.has-scroll-init').length>0){
				setTimeout(() => {
					window.UpdateMyScroll()
	
				}, 400);
			}
        }, 0);
    });


    // }
}



